//@ts-check

class TelemetryService {
	constructor($http, Utility, $timeout, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;
	}

	async logTelemetry(action, description) {
		let url;
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			url = await this.InternalLinksService.getLink('LogTelemetry');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/telemetry/links', false);
				url = await this.InternalLinksService.getLink('LogTelemetry');
			}

			const headers = this.Utility.headersWithContentType;
			const userProfile = this.LocalStorageService.retrieve('userProfile');
			const telemetryLog = {
				action,
				userProfile,
				description
			};

			await this.$http.post(url, telemetryLog, { headers });
			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			const msg = 'Error while logging telemetry';
			this.$timeout(() => promiseHandler.reject(`${msg}\n${error}`));
		}

		return promise;
	}
}

export default /* @ngInject */ ($http, Utility, $timeout, LocalStorageService, InternalLinksService) =>
	new TelemetryService($http, Utility, $timeout, LocalStorageService, InternalLinksService);
